<template>
  <div class="updox-label">
    <label :id="`label-${field.id}`" :for="field.id">
      {{ field.label }}<span class="required" v-if="field.required"> *</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: "LabelField",
    props: {
      field: {
        label: "",
        required: false,
        id: "",
      },
    },
  };
</script>

<style scoped lang="scss">
  .required,
  .error-class {
    color: #d9534f;
  }

  label {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
    display: block;
  }
</style>
